import type { ReactElement } from 'react';
import { getCdnTranslationProps } from '../../utils/server/i18n/getCdnTranslationProps';

import SessionGuard from '../../components/SessionGuard';
import AuthLayout from '../../components/layout/AuthLayout/AuthLayout';
import { SignupPageItem } from '../../components/pages/signup/SignupPageItem';
import { CaptchaScript } from '../../hooks/useCaptcha';

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await getCdnTranslationProps(locale, ['common'])),
  },
  revalidate: 60,
});

function SignUpPage() {
  return <SignupPageItem />;
}

SignUpPage.getLayout = (page: ReactElement) => (
  <AuthLayout
    guard={SessionGuard}
    meta={{
      title: '메타.회원가입.제목',
      description: '메타.회원가입.설명',
      siteTitle: '인프런/랠릿',
    }}
  >
    <CaptchaScript />
    {page}
  </AuthLayout>
);

export default SignUpPage;
